var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroupAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_add_light"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 46",
    cx: 5.95981,
    cy: 6.06772,
    r: 1.71415,
    stroke: "white",
    strokeWidth: 0.685659,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 49",
    d: "M8.5434 6.41081C8.72525 6.09584 9.02477 5.86601 9.37607 5.77188C9.72737 5.67775 10.1017 5.72703 10.4167 5.90888C10.7316 6.09072 10.9615 6.39025 11.0556 6.74155C11.1497 7.09285 11.1004 7.46716 10.9186 7.78213C10.7367 8.0971 10.4372 8.32693 10.0859 8.42106C9.73461 8.5152 9.36031 8.46592 9.04533 8.28407C8.73036 8.10222 8.50053 7.8027 8.4064 7.4514C8.31227 7.10009 8.36155 6.72578 8.5434 6.41081L8.5434 6.41081Z",
    stroke: "white",
    strokeWidth: 0.685659
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    d: "M9.66616 12.5864L9.32761 12.6404L9.66616 12.5864ZM9.04537 12.9244H2.87444V13.6101H9.04537V12.9244ZM2.59219 12.6404C2.68121 12.0823 2.89525 11.289 3.39824 10.6419C3.88874 10.0109 4.66996 9.49615 5.9599 9.49615V8.81049C4.45218 8.81049 3.47349 9.42785 2.85688 10.2211C2.25276 10.9983 2.0125 11.9216 1.91509 12.5324L2.59219 12.6404ZM5.9599 9.49615C7.24984 9.49615 8.03106 10.0109 8.52157 10.6419C9.02455 11.289 9.2386 12.0823 9.32761 12.6404L10.0047 12.5324C9.9073 11.9216 9.66705 10.9983 9.06292 10.2211C8.44632 9.42785 7.46762 8.81049 5.9599 8.81049V9.49615ZM2.87444 12.9244C2.67439 12.9244 2.57065 12.7755 2.59219 12.6404L1.91509 12.5324C1.81736 13.1452 2.31712 13.6101 2.87444 13.6101V12.9244ZM9.04537 13.6101C9.60269 13.6101 10.1024 13.1452 10.0047 12.5324L9.32761 12.6404C9.34915 12.7755 9.24541 12.9244 9.04537 12.9244V13.6101Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtract_2",
    d: "M12.3342 12.5241L12.0016 12.6074L12.3342 12.5241ZM8.56567 10.1685L8.38198 9.87904L8.02875 10.1032L8.31795 10.4055L8.56567 10.1685ZM9.6662 12.5863L10.0048 12.5323V12.5323L9.6662 12.5863ZM11.716 12.9243H9.04541V13.61H11.716V12.9243ZM12.0016 12.6074C12.0385 12.7547 11.9303 12.9243 11.716 12.9243V13.61C12.3131 13.61 12.827 13.0805 12.6668 12.4408L12.0016 12.6074ZM9.73107 10.1817C10.4357 10.1817 10.9306 10.5263 11.2932 11.0092C11.663 11.5018 11.8802 12.1225 12.0016 12.6074L12.6668 12.4408C12.5357 11.9174 12.2905 11.1956 11.8415 10.5975C11.3853 9.98989 10.7048 9.49604 9.73107 9.49604V10.1817ZM8.74936 10.458C9.01665 10.2883 9.33761 10.1817 9.73107 10.1817V9.49604C9.20448 9.49604 8.75655 9.64134 8.38198 9.87904L8.74936 10.458ZM8.31795 10.4055C8.96748 11.0845 9.22693 12.0087 9.32765 12.6403L10.0048 12.5323C9.89543 11.8468 9.60474 10.7587 8.8134 9.93151L8.31795 10.4055ZM9.32765 12.6403C9.34919 12.7754 9.24545 12.9243 9.04541 12.9243V13.61C9.60273 13.61 10.1025 13.1451 10.0048 12.5323L9.32765 12.6403Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 4222",
    x: 11.6165,
    y: 4.18216,
    width: 3.08547,
    height: 0.34283,
    rx: 0.171415,
    stroke: "white",
    strokeWidth: 0.34283,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 4223",
    x: 13.3308,
    y: 2.81106,
    width: 3.08547,
    height: 0.34283,
    rx: 0.171415,
    transform: "rotate(90 13.3308 2.81106)",
    stroke: "white",
    strokeWidth: 0.34283,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupAdd);
export default __webpack_public_path__ + "static/media/GroupAdd.05f1acf79d2a283d5bcf479ea811fb53.svg";
export { ForwardRef as ReactComponent };